import router from '@/router';
import { Message } from 'element-ui';
import { UserModule } from '@/store/modules/user';
import { PermissionModule } from '@/store/modules/permission';

const whiteList = ['Login', 'BusinessJoin', 'BusinessFind', 'NiceAccept', 'NiceDeny'];

/* eslint-disable */
router.beforeEach(async (to: any, _: any, next: any) => {
  if (to.name === 'Login' && to.params && to.params.logout) {
    await UserModule.ResetToken();
    next();
    return;
  }

  if (UserModule.token) {
    if (whiteList.indexOf(to.name) > -1) {
      if (to.name === 'NiceAccept' || to.name === 'NiceDeny') {
        next();
      } else {
        next({ path: '/' });
      }
    } else {
      if (UserModule.roles.length === 0) {
        try {
          await UserModule.GetUserInfo();
          const { roles } = UserModule;
          PermissionModule.GenerateRoutes(roles);
          router.addRoutes(PermissionModule.dynamicRoutes);
          next({ ...to, replace: true });
        } catch (err) {
          UserModule.ResetToken();
          Message.error('사용자 인증에 실패했습니다.');
          next(`/login?redirect=${to.path}`);
        }
      }
      next();
    }
  } else {
    if (whiteList.indexOf(to.name) > -1) {
      next();
    } else {
      next(`/login?redirect=${to.path}`);
    }
  }
});
